import React, { Component } from "react";

import {
  CCard,
  CCardHeader,
  CCardBody,
  CFormGroup,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CSpinner,
  CInput,
  CInputGroupAppend,
  CButton,
  CLabel,
  CSelect,
  CRow,
  CCol,
  CTooltip
} from "@coreui/react";
import { ChromePicker } from "react-color";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Prompt } from "react-router-dom";
import Select from "react-select";
import { InputGroup, Input, InputGroupAddon, InputGroupText } from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import AcessosDoGrupo from "../../../../components/AcessosDoGrupo";
import Breadcrumb from "../../../../components/Breadcrumb";
import {
  dashboards,
  defaultDashboards
} from "../../../../components/Dashboards";
import Form from "../../../../components/Forms/Form";
import { required } from "../../../../components/Forms/validators";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import Uploader from "../../../../components/Uploader/uploader";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

class GroupCreate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      edit: false,
      acessosAberto: false,
      loading: false,
      creating: false,
      generating: false,
      token: "",
      submitButton: false,
      roles: [],
      group_dashboard_selected: [],
      currentRole: 7,
      configureDashboard: false,
      emotion_card: true,
      pickerVisible: null,
      group: {
        name: "",
        primary: "#1e90ff",
        secondary: "#c7c7c7",
        primary_grey: "#f0f0f0",
        footer_color: "#333333"
      },
      // Novos estados para currículos
      curriculosOptions: [],
      curriculosSelected: []
    };

    this.formRef = React.createRef();
    this.error = this.error.bind(this);
    this.fieldsMount = this.fieldsMount.bind(this);
    this.initialValue = this.initialValue.bind(this);
    this.newToken = this.newToken.bind(this);
    this.enviar = this.enviar.bind(this);
    this.atualizar = this.atualizar.bind(this);
    this.curriculosChange = this.curriculosChange.bind(this);
  }

  handleColorClick = fieldName => {
    this.setState({ pickerVisible: fieldName });
  };

  handlePickerClose = () => {
    this.setState({ pickerVisible: null });
  };

  handleColorChange = color => {
    const fieldName = this.state.pickerVisible;
    if (fieldName) {
      this.setState(prevState => ({
        group: {
          ...prevState.group,
          [fieldName]: color.hex
        }
      }));
    }
  };

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  async newToken() {
    this.setState({ generating: true });

    try {
      const resp = await axios.get(`${URL.api}access/group/token`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      });

      this.setState({ token: resp.data.data, generating: false });
    } catch (err) {
      toastr.error("Falha", "Não foi possível gerar o token");
      this.setState({ generating: false });
    }
  }

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);
    this.setState({ creating: true });

    const { id } = this.props.match.params;

    this.setState(
      () => ({
        loading: true
      }),
      () => {
        Promise.all([
          axios.get(`${URL.api}configuration/module/list`, {
            headers: { authorization: `Bearer ${this.props.user.token}` }
          }),
          axios.get(`${URL.api}access/role/list`, {
            headers: { authorization: `Bearer ${this.props.user.token}` }
          }),
          // Nova chamada para buscar currículos
          axios.get(`${URL.api}curriculos/list`, {
            headers: { authorization: `Bearer ${this.props.user.token}` }
          })
        ]).then(
          ([module, role, curriculos]) => {
            // Mapeia os currículos para o formato do react-select
            const curriculosOptions = curriculos.data.data.map(item => ({
              value: item.id,
              label: `${item.nome} - ${item.tipo?.nome || "Sem tipo"}`
            }));

            let fieldsArray = this.fieldsMount(module.data.data);

            this.setState(
              () => ({
                group_module: fieldsArray,
                roles: role.data.data,
                curriculosOptions
              }),
              () => {
                if (!id) {
                  this.setState(() => ({
                    loading: false
                  }));
                }
              }
            );
          },
          () => {
            this.error("Não foi possível carregar os módulos ou currículos");
          }
        );
      }
    );

    if (id) {
      this.setState(
        () => ({
          loading: true
        }),
        () => {
          axios
            .get(`${URL.api}access/group/singleView/${id}`, {
              headers: { authorization: `Bearer ${this.props.user.token}` }
            })
            .then(
              respgroup =>
                axios
                  .get(`${URL.api}configuration/module/list`, {
                    headers: {
                      authorization: `Bearer ${this.props.user.token}`
                    }
                  })
                  .then(respmodule => {
                    let groupModuleSelected = this.initialValue(
                      respgroup.data.data.group_module,
                      respmodule.data.data
                    );

                    // Mapeia os currículos já associados ao grupo
                    const curriculosSelecionados = (
                      respgroup.data.data.group_curriculos || []
                    ).map(item => ({
                      value: item.id,
                      label: `${item.nome} - ${item.tipo?.nome || "Sem tipo"}`
                    }));

                    this.setState(
                      () => ({
                        token: respgroup.data.data.group.token,
                        group: respgroup.data.data.group,
                        group_module_selected: groupModuleSelected,
                        group_dashboard_selected:
                          respgroup.data.data.group_dashboard.map(item => ({
                            role_id: item.role_id,
                            dashboard: item.dashboard,
                            json:
                              typeof item.json === "string" ||
                              item.json instanceof String
                                ? JSON.parse(item.json)
                                : item.json
                          })),
                        emotion_card: respgroup.data.data.group.emotion_card,
                        curriculosSelected: curriculosSelecionados
                      }),
                      () => {
                        this.setState(() => ({
                          edit: true,
                          loading: false
                        }));
                      }
                    );
                  }),
              error => {
                this.error("Não foi possível carregar os módulos");
              },
              error => {
                this.error("Não foi possível carregar o grupo");
              }
            );
        }
      );
    }
  }

  changeEmotionCardFlag(e) {
    let { value } = e.target;
    this.setState({ emotion_card: value });
  }

  fieldsMount(value) {
    let arrayModule = [];
    let objModule = {};
    objModule.label = "Módulo comercial";
    objModule.options = [];

    for (let i = 0; i < value.length; i++) {
      let objModuleList = {};
      objModuleList.value = value[i].id;
      objModuleList.label = value[i].name;
      objModule.options.push(objModuleList);
    }

    arrayModule.push(objModule);

    return arrayModule;
  }

  initialValue(groupModule, moduleList) {
    let initialValue = [];
    for (let i = 0; i < groupModule.length; i++) {
      for (let j = 0; j < moduleList.length; j++) {
        if (groupModule[i].module_id === moduleList[j].id) {
          let objModuleList = {};
          objModuleList.value = moduleList[j].id;
          objModuleList.label = moduleList[j].name;
          initialValue.push(objModuleList);
        }
      }
    }

    return initialValue;
  }

  enviar(value) {
    if (!value.name) {
      toastr.warning("Campo inválido", "O nome não foi preenchido");
      return;
    }

    if (!this.state.token) {
      toastr.warning("Campo inválido", "O token não foi gerado");
      return;
    }

    this.setState({ submitButton: true });

    let groupModuleSelected = this.state.group_module_selected.map(
      item => item.value
    );

    let obj = {
      loggedUser: this.props.user.user.id,
      name: value.name,
      logo: this.state.logo,
      primary: this.state.group.primary,
      secondary: this.state.group.secondary,
      primary_grey: this.state.group.primary_grey,
      footer_color: this.state.group.footer_color,
      module: groupModuleSelected,
      dashboard: this.state.group_dashboard_selected.map(item => ({
        ...item,
        json: JSON.stringify(item.json)
      })),
      token: this.state.token,
      emotion_card: this.state.emotion_card,
      curriculos: this.state.curriculosSelected.map(item => item.value) // IDs dos currículos
    };

    axios
      .post(`${URL.api}access/group/insert`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          if (resp.data.success) {
            this.props.history.push("/group/list");
            this.setState({ creating: false, submitButton: false });
          } else {
            this.error("Não foi possível inserir o grupo");
            this.setState({ creating: false, submitButton: false });
          }
        },
        error => {
          this.error("Não foi possível inserir o grupo");
          this.setState({ creating: false, submitButton: false });
        }
      );
  }

  atualizar(value) {
    if (!value.name) {
      toastr.warning("Campo inválido", "O nome não foi preenchido");
      return;
    }

    if (!this.state.token) {
      toastr.warning("Campo inválido", "O token não foi gerado");
      return;
    }

    this.setState({ submitButton: true });

    let groupModuleSelected = this.state.group_module_selected.map(
      item => item.value
    );
    let obj = {
      loggedUser: this.props.user.user.id,
      name: value.name,
      logo: this.state.logo,
      primary: this.state.group.primary,
      secondary: this.state.group.secondary,
      primary_grey: this.state.group.primary_grey,
      footer_color: this.state.group.footer_color,
      module: groupModuleSelected,
      dashboard: this.state.group_dashboard_selected.map(item => ({
        ...item,
        json: JSON.stringify(item.json)
      })),
      token: this.state.token,
      emotion_card: this.state.emotion_card,
      curriculos: this.state.curriculosSelected.map(item => item.value) // IDs dos currículos
    };

    axios
      .post(`${URL.api}access/group/update/${value.id}`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          if (resp.data.success) {
            this.props.history.push("/group/list");
            this.setState({ creating: false, submitButton: false });
          } else {
            this.error("Não foi possível editar o grupo");
            this.setState({ creating: false, submitButton: false });
          }
        },
        error => {
          this.error("Não foi possível editar o grupo");
          this.setState({ creating: false, submitButton: false });
        }
      );
  }

  done(uploads) {
    this.setState(() => ({
      logo: uploads[0]
    }));
  }

  optionsChange = e => {
    this.setState({
      group_module_selected: e
    });
  };

  curriculosChange = selected => {
    this.setState({ curriculosSelected: selected || [] });
  };

  selectDashboard(dashboard) {
    this.setState(state => ({
      group_dashboard_selected: [
        ...state.group_dashboard_selected.filter(
          item => item.role_id !== state.currentRole
        ),
        {
          role_id: state.currentRole,
          dashboard: dashboard.name,
          json: null
        }
      ]
    }));
  }

  configureDashboard(dashboard) {
    if (!dashboard.configComponent) {
      toastr.info("Informação", "Não há configurações para este dashboard");
      return;
    }

    this.setState({ configureDashboard: true });
  }

  changeConfiguration(dashboardName, json) {
    this.setState(state => ({
      group_dashboard_selected: [
        ...state.group_dashboard_selected.filter(
          item => item.role_id !== state.currentRole
        ),
        {
          role_id: state.currentRole,
          dashboard: dashboardName,
          json
        }
      ]
    }));
  }

  render() {
    const { pickerVisible, group } = this.state;

    const popover = {
      position: "absolute",
      zIndex: "2",
      right: 0
    };
    const cover = {
      position: "fixed",
      top: "0px",
      right: "0px",
      bottom: "0px",
      left: "0px"
    };
    const selectedDashboard =
      this.state.group_dashboard_selected.find(
        item => item.role_id === this.state.currentRole
      )?.dashboard ||
      defaultDashboards[
        this.state.roles.find(role => role.id === this.state.currentRole)
          ?.type || "A"
      ];

    const SelectedDashboardConfig = dashboards.find(
      item => item.name === selectedDashboard
    )?.configComponent;

    return (
      <React.Fragment>
        <Breadcrumb
          current={this.props.currentRoute}
          items={[{ path: "/group/list", to: "/group/list" }]}
        />
        <Prompt
          when={!this.state.creating}
          message="Os dados do formulário ainda não foram salvos. Tem certeza de que deseja sair desta página?"
        />
        {this.state.loading ? (
          <Loading />
        ) : (
          <CCard>
            <CCardHeader className="d-flex align-items-center">
              <div
                style={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <h4 className="card-title mb-1">
                  {this.state.edit ? "Editar Grupo" : "Criar Grupo"}
                </h4>
                <div className="small text-muted">
                  {this.state.edit
                    ? "Edite o grupo selecionado"
                    : "Crie um novo grupo"}
                </div>
              </div>
              {/* Acesso às telas por perfil neste grupo. Só para grupo já
                  salvo: as decisões ficam presas ao group_id. */}
              {this.state.edit && (
                <CButton
                  color="secondary"
                  variant="outline"
                  className="mr-2"
                  onClick={() => this.setState({ acessosAberto: true })}
                >
                  <i className="fa fa-lock mr-2" />
                  Editar acessos
                </CButton>
              )}
              <CButton
                color="primary"
                className="d-flex justify-content-center align-items-center"
                onClick={() => this.formRef.current.submit()}
                disabled={!this.state.creating}
              >
                <>
                  <span style={this.state.submitButton ? { opacity: 0 } : null}>
                    <i className="fa fa-cloud-upload mr-2"></i>Salvar
                  </span>
                  {this.state.submitButton && (
                    <CSpinner
                      size="sm"
                      color="white"
                      style={{ position: "absolute" }}
                    />
                  )}
                </>
              </CButton>
            </CCardHeader>
            <CCardBody>
              <Uploader
                type="group"
                maxFiles={1}
                acceptedFileTypes={["image/*"]}
                allowMultiple
                labelIdle='Arraste e solte sua imagem ou <span class="filepond--label-action">procure</span>'
                done={uploads => this.done(uploads)}
              />
              <Form
                avatar
                fields={Fields}
                ref={this.formRef}
                history={this.props.history}
                onSubmit={this.state.edit ? this.atualizar : this.enviar}
                initialValues={this.state.group}
                edit={this.state.group}
              />

              <CRow>
                <CCol md="6">
                  <CFormGroup className="position-relative">
                    <CLabel>
                      Cor primária
                      <CTooltip
                        content={
                          <div
                            style={{
                              position: "relative",
                              display: "inline-block",
                              cursor: "pointer"
                            }}
                          >
                            <div
                              style={{
                                position: "absolute",
                                bottom: "125%",
                                left: "50%",
                                transform: "translateX(-50%)",
                                backgroundColor: "#818181ff",
                                color: "#fff",
                                padding: "8px",
                                borderRadius: "6px",
                                fontSize: "12px",
                                maxWidth: "550px",
                                zIndex: 1000,
                                whiteSpace: "normal",
                                textAlign: "left",
                                boxShadow: "0px 2px 6px rgba(0,0,0,0.3)"
                              }}
                            >
                              <p style={{ marginBottom: "10px" }}>
                                Usada nos botões principais, em todo o menu
                                lateral e destaques de navegação.
                              </p>
                              <br />
                              <img
                                src="/imgs/exemplos/corPrimaria.png"
                                alt="Exemplo cor secundária"
                                style={{
                                  maxWidth: "520px",
                                  borderRadius: "6px",
                                  border: "1px solid #ccc",
                                  display: "block"
                                }}
                              />
                              <div
                                style={{
                                  position: "absolute",
                                  top: "100%",
                                  left: "50%",
                                  transform: "translateX(-50%)",
                                  width: 0,
                                  height: 0,
                                  borderLeft: "6px solid transparent",
                                  borderRight: "6px solid transparent",
                                  borderTop: "6px solid #333"
                                }}
                              />
                            </div>
                          </div>
                        }
                      >
                        <span
                          style={{
                            textDecoration: "underline",
                            cursor: "pointer"
                          }}
                        >
                          <i
                            className="fa fa-info-circle text-muted"
                            style={{ cursor: "pointer", marginLeft: "5px" }}
                          />
                        </span>
                      </CTooltip>
                    </CLabel>
                    <CInputGroup
                      onClick={() => this.handleColorClick("primary")}
                      style={{ cursor: "pointer" }}
                      className={
                        pickerVisible === "primary" ? "is-focused" : ""
                      }
                    >
                      <CInputGroupPrepend>
                        <CInputGroupText>
                          <i className="fa fa-paint-brush"></i>
                        </CInputGroupText>
                      </CInputGroupPrepend>
                      <CInput
                        type="text"
                        value={this.state.group.primary}
                        readOnly
                        style={{ cursor: "pointer" }}
                      />
                      <CInputGroupAppend>
                        <div
                          style={{
                            backgroundColor: this.state.group.primary,
                            width: "40px",
                            border: "1px solid #ced4da"
                          }}
                        />
                      </CInputGroupAppend>
                    </CInputGroup>
                    {this.state.pickerVisible === "primary" && (
                      <div style={popover}>
                        <div style={cover} onClick={this.handlePickerClose} />
                        <ChromePicker
                          color={this.state.group.primary}
                          onChangeComplete={this.handleColorChange}
                          disableAlpha
                        />
                      </div>
                    )}
                  </CFormGroup>
                </CCol>
                <CCol md="6">
                  <CFormGroup className="position-relative">
                    <CLabel>
                      Cor Secundária
                      <CTooltip
                        content={
                          <div
                            style={{
                              position: "relative",
                              display: "inline-block",
                              cursor: "pointer"
                            }}
                          >
                            <div
                              style={{
                                position: "absolute",
                                bottom: "125%",
                                left: "50%",
                                transform: "translateX(-50%)",
                                backgroundColor: "#818181ff",
                                color: "#fff",
                                padding: "8px",
                                borderRadius: "6px",
                                fontSize: "12px",
                                maxWidth: "550px",
                                zIndex: 1000,
                                whiteSpace: "normal",
                                textAlign: "left",
                                boxShadow: "0px 2px 6px rgba(0,0,0,0.3)"
                              }}
                            >
                              <p style={{ marginBottom: "10px" }}>
                                Usada em elementos de apoio, caixas de conteúdo
                                e destaques do menu.
                              </p>
                              <br />
                              <img
                                src="/imgs/exemplos/corSecundaria.png"
                                alt="Exemplo cor secundária"
                                style={{
                                  maxWidth: "520px",
                                  borderRadius: "6px",
                                  border: "1px solid #ccc",
                                  display: "block"
                                }}
                              />
                              <div
                                style={{
                                  position: "absolute",
                                  top: "100%",
                                  left: "50%",
                                  transform: "translateX(-50%)",
                                  width: 0,
                                  height: 0,
                                  borderLeft: "6px solid transparent",
                                  borderRight: "6px solid transparent",
                                  borderTop: "6px solid #333"
                                }}
                              />
                            </div>
                          </div>
                        }
                      >
                        <span
                          style={{
                            textDecoration: "underline",
                            cursor: "pointer"
                          }}
                        >
                          <i
                            className="fa fa-info-circle text-muted"
                            style={{ cursor: "pointer", marginLeft: "5px" }}
                          />
                        </span>
                      </CTooltip>
                    </CLabel>
                    <CInputGroup
                      onClick={() => this.handleColorClick("secondary")}
                      style={{ cursor: "pointer" }}
                      className={
                        pickerVisible === "secondary" ? "is-focused" : ""
                      }
                    >
                      <CInputGroupPrepend>
                        <CInputGroupText>
                          <i className="fa fa-paint-brush"></i>
                        </CInputGroupText>
                      </CInputGroupPrepend>
                      <CInput
                        type="text"
                        value={this.state.group.secondary}
                        readOnly
                        style={{ cursor: "pointer" }}
                      />
                      <CInputGroupAppend>
                        <div
                          style={{
                            backgroundColor: this.state.group.secondary,
                            width: "40px",
                            border: "1px solid #ced4da"
                          }}
                        />
                      </CInputGroupAppend>
                    </CInputGroup>
                    {this.state.pickerVisible === "secondary" && (
                      <div style={popover}>
                        <div style={cover} onClick={this.handlePickerClose} />
                        <ChromePicker
                          color={this.state.group.secondary}
                          onChangeComplete={this.handleColorChange}
                          disableAlpha
                        />
                      </div>
                    )}
                  </CFormGroup>
                </CCol>
              </CRow>

              <CRow>
                <CCol md="6">
                  <CFormGroup className="position-relative">
                    <CLabel>
                      Cinza primário
                      <CTooltip
                        content={
                          <div
                            style={{
                              position: "relative",
                              display: "inline-block",
                              cursor: "pointer"
                            }}
                          >
                            <div
                              style={{
                                position: "absolute",
                                bottom: "125%",
                                left: "50%",
                                transform: "translateX(-50%)",
                                backgroundColor: "#818181ff",
                                color: "#fff",
                                padding: "8px",
                                borderRadius: "6px",
                                fontSize: "12px",
                                maxWidth: "550px",
                                zIndex: 1000,
                                whiteSpace: "normal",
                                textAlign: "left",
                                boxShadow: "0px 2px 6px rgba(0,0,0,0.3)"
                              }}
                            >
                              <p style={{ marginBottom: "10px" }}>
                                Usada em ícones e pequenos detalhes visuais. É
                                recomendado usar um tom de cinza de médio a
                                claro para melhor contraste.
                              </p>
                              <br />
                              <img
                                src="/imgs/exemplos/cinzaPrimario.png"
                                alt="Exemplo cor secundária"
                                style={{
                                  maxWidth: "520px",
                                  borderRadius: "6px",
                                  border: "1px solid #ccc",
                                  display: "block"
                                }}
                              />
                              <div
                                style={{
                                  position: "absolute",
                                  top: "100%",
                                  left: "50%",
                                  transform: "translateX(-50%)",
                                  width: 0,
                                  height: 0,
                                  borderLeft: "6px solid transparent",
                                  borderRight: "6px solid transparent",
                                  borderTop: "6px solid #333"
                                }}
                              />
                            </div>
                          </div>
                        }
                      >
                        <span
                          style={{
                            textDecoration: "underline",
                            cursor: "pointer"
                          }}
                        >
                          <i
                            className="fa fa-info-circle text-muted"
                            style={{ cursor: "pointer", marginLeft: "5px" }}
                          />
                        </span>
                      </CTooltip>
                    </CLabel>
                    <CInputGroup
                      onClick={() => this.handleColorClick("primary_grey")}
                      style={{ cursor: "pointer" }}
                      className={
                        pickerVisible === "primary_grey" ? "is-focused" : ""
                      }
                    >
                      <CInputGroupPrepend>
                        <CInputGroupText>
                          <i className="fa fa-paint-brush"></i>
                        </CInputGroupText>
                      </CInputGroupPrepend>
                      <CInput
                        type="text"
                        value={this.state.group.primary_grey}
                        readOnly
                        style={{ cursor: "pointer" }}
                      />
                      <CInputGroupAppend>
                        <div
                          style={{
                            backgroundColor: this.state.group.primary_grey,
                            width: "40px",
                            border: "1px solid #ced4da"
                          }}
                        />
                      </CInputGroupAppend>
                    </CInputGroup>
                    {this.state.pickerVisible === "primary_grey" && (
                      <div style={popover}>
                        <div style={cover} onClick={this.handlePickerClose} />
                        <ChromePicker
                          color={this.state.group.primary_grey}
                          onChangeComplete={this.handleColorChange}
                          disableAlpha
                        />
                      </div>
                    )}
                  </CFormGroup>
                </CCol>
                <CCol md="6">
                  <CFormGroup className="position-relative">
                    <CLabel>
                      Cor do rodapé
                      <CTooltip content="Essa cor não é mais utilizada em nenhum lugar da plataforma.">
                        <i
                          className="fa fa-info-circle text-muted"
                          style={{ cursor: "pointer", marginLeft: "5px" }}
                        />
                      </CTooltip>
                    </CLabel>
                    <CInputGroup
                      onClick={() => this.handleColorClick("footer_color")}
                      style={{ cursor: "pointer" }}
                      className={
                        pickerVisible === "footer_color" ? "is-focused" : ""
                      }
                    >
                      <CInputGroupPrepend>
                        <CInputGroupText>
                          <i className="fa fa-paint-brush"></i>
                        </CInputGroupText>
                      </CInputGroupPrepend>
                      <CInput
                        type="text"
                        value={this.state.group.footer_color}
                        readOnly
                        style={{ cursor: "pointer" }}
                      />
                      <CInputGroupAppend>
                        <div
                          style={{
                            backgroundColor: this.state.group.footer_color,
                            width: "40px",
                            border: "1px solid #ced4da"
                          }}
                        />
                      </CInputGroupAppend>
                    </CInputGroup>
                    {this.state.pickerVisible === "footer_color" && (
                      <div style={popover}>
                        <div style={cover} onClick={this.handlePickerClose} />
                        <ChromePicker
                          color={this.state.group.footer_color}
                          onChangeComplete={this.handleColorChange}
                          disableAlpha
                        />
                      </div>
                    )}
                  </CFormGroup>
                </CCol>
              </CRow>

              <CFormGroup>
                <CLabel>Segmento</CLabel>
                <CInputGroup className="flex-nowrap">
                  <CInputGroupPrepend>
                    <CInputGroupText>
                      <i className="fa fa-text-width"></i>
                    </CInputGroupText>
                  </CInputGroupPrepend>
                  <Select
                    isMulti
                    placeholder="Segmento"
                    name="Segmento"
                    options={this.state.group_module}
                    defaultValue={this.state.group_module_selected}
                    className="basic-multi-select flex-1"
                    classNamePrefix="select"
                    onChange={e => this.optionsChange(e)}
                  />
                </CInputGroup>
              </CFormGroup>

              {/* NOVO CAMPO: Currículos */}
              <CFormGroup>
                <CLabel>Currículos</CLabel>
                <CInputGroup className="flex-nowrap">
                  <CInputGroupPrepend>
                    <CInputGroupText>
                      <i className="fa fa-book"></i>
                    </CInputGroupText>
                  </CInputGroupPrepend>
                  <Select
                    isMulti
                    placeholder="Selecione os currículos"
                    name="curriculos"
                    options={this.state.curriculosOptions}
                    value={this.state.curriculosSelected}
                    className="basic-multi-select flex-1"
                    classNamePrefix="select"
                    onChange={this.curriculosChange}
                    formatOptionLabel={option => (
                      <div>
                        <span>{option.label}</span>
                      </div>
                    )}
                  />
                </CInputGroup>
              </CFormGroup>

              <CFormGroup>
                <CLabel>Card Emoções</CLabel>
                <InputGroup>
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="fa fa-text-width" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    type="select"
                    value={this.state.emotion_card}
                    onChange={e => this.changeEmotionCardFlag(e)}
                  >
                    <option key={1} value="true">
                      Sim
                    </option>
                    <option key={2} value="false">
                      Não
                    </option>
                  </Input>
                </InputGroup>
              </CFormGroup>

              <CFormGroup>
                <CLabel>Token</CLabel>
                <CInputGroup className="flex-nowrap">
                  <CInputGroupPrepend>
                    <CInputGroupText>
                      <i className="fa fa-puzzle-piece"></i>
                    </CInputGroupText>
                  </CInputGroupPrepend>
                  <CInput
                    type="text"
                    value={this.state.token}
                    readOnly
                    placeholder="Token"
                  />
                  <CInputGroupAppend
                    onClick={!this.state.generating && this.newToken}
                    className="cursor"
                  >
                    <CInputGroupText className="d-flex align-items-center justify-content-center">
                      <>
                        <span
                          style={this.state.generating ? { opacity: 0 } : null}
                        >
                          Gerar
                        </span>
                        {this.state.generating && (
                          <CSpinner
                            size="sm"
                            color="dark"
                            style={{ position: "absolute" }}
                          />
                        )}
                      </>
                    </CInputGroupText>
                  </CInputGroupAppend>
                </CInputGroup>
              </CFormGroup>

              <CFormGroup>
                <CLabel>Dashboards</CLabel>
                <CSelect
                  className="w-auto"
                  value={this.state.currentRole}
                  onChange={e =>
                    this.setState({ currentRole: parseInt(e.target.value) })
                  }
                >
                  {this.state.roles
                    .filter(role => role.type !== "G")
                    .map(role => (
                      <option value={role.id}>{role.name}</option>
                    ))}
                </CSelect>
                <CRow>
                  {dashboards
                    .filter(dashboard =>
                      dashboard.roleTypes.includes(
                        this.state.roles.find(
                          role => role.id === this.state.currentRole
                        )?.type || "A"
                      )
                    )
                    .map(dashboard => (
                      <CCol xs="3" className="mt-3 d-flex flex-column">
                        <img
                          src={dashboard.image}
                          style={{ height: "auto" }}
                          className="mb-2"
                          title={dashboard.name}
                        />
                        <CButton
                          variant={
                            dashboard.name !== selectedDashboard
                              ? "outline"
                              : undefined
                          }
                          color={
                            dashboard.name !== selectedDashboard
                              ? "light"
                              : "primary"
                          }
                          className={
                            dashboard.name !== selectedDashboard
                              ? "text-muted"
                              : ""
                          }
                          onClick={() =>
                            dashboard.name !== selectedDashboard
                              ? this.selectDashboard(dashboard)
                              : this.configureDashboard(dashboard)
                          }
                        >
                          {dashboard.name !== selectedDashboard
                            ? "Selecionar"
                            : "Configurar"}
                        </CButton>
                      </CCol>
                    ))}
                </CRow>
              </CFormGroup>
            </CCardBody>
          </CCard>
        )}
        {SelectedDashboardConfig && this.state.configureDashboard && (
          <SelectedDashboardConfig
            show={this.state.configureDashboard}
            json={
              this.state.group_dashboard_selected.find(
                item => item.role_id === this.state.currentRole
              )?.json || null
            }
            onChange={dashboardConfig =>
              this.changeConfiguration(selectedDashboard, dashboardConfig)
            }
            onClose={() => this.setState({ configureDashboard: false })}
          />
        )}
        {this.state.edit && this.state.acessosAberto && (
          <AcessosDoGrupo
            show
            onClose={() => this.setState({ acessosAberto: false })}
            groupId={this.props.match.params.id}
            groupName={this.state.group?.name}
            token={this.props.user.token}
          />
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

let Fields = [
  {
    name: "name",
    label: "Nome",
    type: "text",
    required: true,
    icon: "fa fa-text-width",
    value: "",
    validate: [required]
  }
];

export default connect(mapStateToProps, mapDispatchToProps)(GroupCreate);
